export const ERP_SYSTEM_NAME = "Dyntechs ERP System";
export const ERP_SHORT_NAME = "Dyntechs ERP";
export const ERP_SESSION_LABEL = "Dyntechs ERP session";

export const BRANDING = {
  systemName: ERP_SYSTEM_NAME,
  shortName: ERP_SHORT_NAME,
  sessionLabel: ERP_SESSION_LABEL,
  signingIn: "Signing you in with your Dyntechs session...",
  signInServerUnavailable:
    "The server could not sign you in. Your Dyntechs ERP session may be busy or expired. Tap “Retry sign-in” below.",
  signInTimeout:
    "Sign-in is taking too long. Tap “Retry sign-in” below to refresh your Dyntechs ERP session.",
  signInGenericFailure:
    "Could not authenticate embedded dashboard. Tap “Retry sign-in” below.",
  retrySignInHint:
    "This clears cached dashboard tokens and requests a fresh sign-in from your current Dyntechs ERP session.",
  sessionExpiredRefreshPage: `Your session expired. Refresh the ${ERP_SYSTEM_NAME} page.`,
  sessionExpiredRefreshPageSignIn: `Your session expired. Refresh the ${ERP_SYSTEM_NAME} page to sign in again.`,
  sessionExpiredSignInAgain: "Your session expired. Please sign in again.",
  apiSessionExpired: `Your API session expired. Refresh this ${ERP_SYSTEM_NAME} page to restore access.`,
  noActiveSession: `Your ${ERP_SESSION_LABEL} expired. Refresh the ${ERP_SYSTEM_NAME} page.`,
  missingEmbeddedOrigin:
    "Missing ERP origin. Open the dashboard from Dyntechs ERP or configure REACT_APP_ODOO_ORIGIN.",
  googleMapsNotConfiguredTitle: "Map unavailable",
  googleMapsNotConfiguredMessage: `Google Maps is not configured for this dashboard. Ask your administrator to add a Google Maps API key in ${ERP_SYSTEM_NAME} settings under Delivery Dashboard.`,
} as const;

/** Replace legacy Odoo wording in user-visible API/auth messages. */
export function sanitizeErpBranding(text: string): string {
  return text
    .replace(/\bOdoo session\b/gi, ERP_SESSION_LABEL)
    .replace(/\bOdoo page\b/gi, `${ERP_SYSTEM_NAME} page`)
    .replace(/\bOdoo\b/gi, ERP_SHORT_NAME);
}
